<!--
 * @Author:
 * @LastEditTime: 2024-07-09 15:24:58
 * @Description:
-->
<template>
  <div class="rounded-2px z-99 w-full h-full pt-10px relative">
    <!-- <p>电气第一种工作票{{ transferProps.code }}</p>
    <el-button @click="reviewDetail">作业态势感知</el-button> -->
    <div class="w-full h-full flex flex-col justify-between">
      <div class="h-3/8 ">
        <div class="w-full h-1/6 flex justify-between items-center">
          <CategoryTitle title="作业基础情况" class="my-5px" />
          <div
            class="flex items-center text-white bg-[#59D4A0] text-14px px-15px py-5px text-opacity-90"
          >
            {{ transferProps.buildingId.prTicketState || '--' }}
          </div>
        </div>
        <div class="w-full h-5/6 flex justify-between items-center text-14px py-10px">
          <el-row class="w-full h-full">
            <el-col
              :span="8"
              class="text-right pl-10px text-white-60 h-full flex flex-col justify-between"
            >
              <div v-for="(item, index) in workInfoTitle" :key="index" class="">{{ item }}：</div>
            </el-col>
            <el-col :span="16" class="text-white h-full flex flex-col justify-between">
              <el-tooltip
                placement="top"
                :content="transferProps.buildingId.prWorkContent"
                v-if="transferProps.buildingId.prWorkContent"
              >
                <div class="truncate">{{ transferProps.buildingId.prWorkContent || '-' }}</div>
              </el-tooltip>
              <div>{{ transferProps.buildingId.prDeviceCode || '-' }}</div>
              <div>{{ transferProps.buildingId.prWorkManagerName || '-' }}</div>
              <div class="text-[#00BCC8]">
                {{ transferProps.buildingId.prWorkGroupMember || '-' }}
              </div>
              <div class="text-[#59D4A0]">{{ transferProps.buildingId.prPiskLevel || '-' }}</div>
              <div>{{ transferProps.buildingId.prPlanningWorkBeginTime || '-' }}</div>
              <div>{{ transferProps.buildingId.prPlanningWorkEndTime || '-' }}</div>
              <div>{{ transferProps.buildingId.prTicketFinishTime || '-' }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="h-3/8 flex flex-col justify-between">
        <div class="w-full flex justify-between items-center video-select">
          <CategoryTitle title="关联作业视频" class="my-5px" />
          <el-select
            v-model="cameraCode"
            popper-class="visualization-select-popper"
            size="small"
            class="w-115px"
            @change="cameraChange"
            filterable
          >
            <el-option
              v-for="item in cameraList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <div
            @click="reviewDetail"
            class="btn-bg1 cursor-pointer w-96px h-36px text-white flex justify-center items-center text-14px"
          >
            态势感知
          </div>
        </div>
        <div class="w-20/21 h-[calc(100%-45px)] mx-auto">
          <YSPlayer v-if="showPlayer" :code="camera.code" :pIid="camera.pIid" class="w-full h-full"></YSPlayer>
          <div v-else class="w-full h-full flex justify-center items-center">
            <img src="../../../assets/images/no_data@1x.png" alt="" />
          </div>
        </div>
      </div>
      <div class="h-2/8 flex flex-col justify-between">
        <div class="w-full h-1/5 flex justify-between items-center">
          <div @click="checkAllAlarm"><CategoryTitle title="作业风险预警" class="my-5px cursor-pointer" /></div>
          <div class="btn-bg2 w-170px h-24px text-white flex justify-center items-center text-14px">
            <span class="truncate" v-if="alertTable">{{ alertTable[0] && alertTable[0].fenceName || '-' }}</span>
          </div>
        </div>
        <div class="h-4/5">
          <el-table
            class="mt-5px mb-10px"
            :height="tableHeight"
            :data="alertTable"
            v-loading="alertLoading"
            highlight-current-row
            element-loading-text="正在加载..."
          >
            <el-table-column
              label="报警类型"
              prop="alarmTypeName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="报警对象"
              prop="personNames"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="确认时间"
              prop="eventStartTime"
              :formatter="formatDate"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <WorkSituationalAwareness
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px"
    ></WorkSituationalAwareness>
    <WorkAlarmList
      v-if="isShowAlarmDialog"
      :isShowDialog.sync="isShowAlarmDialog"
    ></WorkAlarmList>
  </div>
</template>
<script>
import { compact, map } from 'lodash'
// apis
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import { IOTDeviceApi, Tag3DCameraPositionsApi } from '@wiz-api/iot-device-management'
import { WorkTicketsApi } from '@wiz-api/huizhou2-business'

//
const alarmRecordApi = new StandardAlarmRecordApi()
const iotDeviceApi = new IOTDeviceApi()
const workTicketsApi = new WorkTicketsApi()
const tag3DCameraPositionsApi = new Tag3DCameraPositionsApi()
// components
const CategoryTitle = () => {
  return import('@/components/cockpit/CategoryTitle')
}
const YSPlayer = () => {
  return import('../components/video/YSPlayer/newYSPlayer')
}
const WorkSituationalAwareness = () => {
  return import('./WorkSituationalAwareness')
}
const WorkAlarmList = () => {
  return import('./WorkAlarmList')
}

export default {
  name: 'DigitalEngineering',
  components: {
    WorkSituationalAwareness,
    CategoryTitle,
    YSPlayer,
    WorkAlarmList
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(val) {
        console.log(val, '-----r-----')
      },
      immediate: true,
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 5px)'
    },
    // 驾驶舱配置
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-cockpit']?.config
    },
    nearbyNumber() {
      return this.modelSetting?.cameraListConfig?.nearbyNumber || 10
    },
  },
  created() {
    this.getAlarmingList()
    this.getCameraList()
  },
  data() {
    return {
      isShowDialog: false,
      isShowAlarmDialog: false,
      // 作业基础信息
      workStatus: '工作中',
      workInfoTitle: [
        '工作内容',
        '设备设施编号',
        '作业负责人',
        '工作班成员',
        '风险等级',
        '许可开始时间',
        '计划结束时间',
        '作业终结状态',
      ],
      workInfoContent: [],
      // 作业风险预警
      alertTable: [{ fenceName: '' }],
      alertLoading: false,
      // 关联作业视频
      cameraList: [],
      cameraCode: '',
      camera: {
        code: '',
        pIid: '',
      },
      showPlayer: false,
    }
  },
  methods: {
    rowClick() {},
    reviewDetail(item) {
      this.isShowDialog = true
    },
    refresh() {
      this.isShowDialog = false
    },
    checkAllAlarm() {
      this.isShowAlarmDialog = true
    },
    // 获取关联列表
    async getRelevanceList() {
      const [err, res] = await workTicketsApi.getWorkTicketStandardFenceRelevanceByList({
        body: {
          workTicketIds: [this.transferProps.buildingId.prId],
          standardFenceIds: [],
        }
      })
      if (!err && res) {
        this.relevanceList = res.items
        // 关联作业类型下拉数据源
        this.standardFenceIds = compact(map(this.relevanceList, 'standardFenceId'))
        this.standardFenceIdsStr = this.standardFenceIds.join(',')
      }
    },
    // 作业风险预警数据
    async getAlarmingList() {
      this.alarmingLoading = true
      await this.getRelevanceList()
      if (!this.standardFenceIdsStr) {
        this.alarmingLoading
        return
      }
      const [err, res] = await alarmRecordApi.getList({
        alarmType: '',
        dataSource: '',
        startTime: '',
        endTime: '',
        alarmRemoveType: 0,
        standardFenceIdsStr: this.standardFenceIdsStr,
        maxResultCount: 9999,
        skipCount: 0,
      })
      this.alarmingLoading = false
      if (!err && res) {
        this.alertTable = res.items
      }
    },
    // 获取设备关联摄像头
    async getCameraList() {
      if (!this.transferProps.buildingId.prDeviceCode) {
        return
      }
      const [err, res] = await iotDeviceApi.getDeviceWithDetailPageList({
        relevanceDevice: this.transferProps.buildingId.prDeviceCode, // String |
        maxResultCount: 50, // Number |
      })
      if (!err) {
        this.cameraList = res.items
        if (res.items.length > 0) {
          const cameraInfo = res.items[0]
          this.cameraCode = cameraInfo.name
          // 视频参数
          this.camera.code = cameraInfo.code
          this.camera.pIid = cameraInfo.pIid
          this.showPlayer = true
        }
      }
      this.getNearCamera()
    },
    // 获取设备附近摄像头
    async getNearCamera() {
      const visibleInfo = await this.cloudRender.NodeProxy.getInfo('Code', this.transferProps.buildingId.prDeviceCode)
      if (visibleInfo.data) {
        const position = await this.cloudRender.NodeProxy.getAabb(visibleInfo.data)
        if (position.data?.aabb) {
          // 获取设备位置信息
          const leftBottom = position.data.aabb[0]
          const rightTop = position.data.aabb[1]
          const pos = [
            (leftBottom[0] + rightTop[0]) / 2,
            (leftBottom[1] + rightTop[1]) / 2,
            (leftBottom[2] + rightTop[2]) / 2,
          ]
          const [err, res] = await tag3DCameraPositionsApi.getNearbyCameras({
            x: pos[0],
            y: pos[1],
            _number: this.nearbyNumber,
          })
          if (!err && res) {
            this.cameraList = [...this.cameraList, ...res]
            if (!this.cameraCode && res.length) {
              this.cameraCode = res[0].name
              this.camera.code = res[0].code
              this.camera.pIid = res[0].pIid
              this.showPlayer = true
            }
          }
        }
      }
    },
    cameraChange(code) {
      const cameraInfo = this.cameraList.find((item) => { return item.code === code })
      if (cameraInfo) {
        this.camera.code = cameraInfo.code
        this.camera.pIid = cameraInfo.pIid
      }
    },
    // 时间格式化
    formatDate(row, column) {
      const data = row[column.property]
      if (data === null || data === undefined) {
        return null
      }
      const date = new Date(data)
      return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}` || '--'
    },
  }
}
</script>
<style lang="scss" scoped>
.btn-bg1 {
  background-image: url('../../../assets/images/workAPicture/btn-bg-image1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.btn-bg2 {
  background-image: url('../../../assets/images/workAPicture/btn-bg-image2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.text-white-60 {
  color: white;
  opacity: 0.6;
}
.video-select {
  ::v-deep .el-input__inner:not([tabindex]) {
    height: 28px !important;
  }
  ::v-deep .el-input .el-input__icon {
    line-height: 28px !important;
  }
}
</style>
